export const PENDING_INVITATION_KEY = 'tidyping.pending-client-invitation'
export const PENDING_TEAM_INVITATION_KEY = 'tidyping.pending-team-invitation'
export const INVITATION_HOST = 'https://tidyping.com'

export function normalizeInvitationCode(value: string) {
  return value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 20)
}

export function formatInvitationCode(value: string) {
  return normalizeInvitationCode(value).match(/.{1,4}/g)?.join('-') ?? ''
}

export function isValidInvitationCode(value: string) {
  return /^TIDY[0-9A-F]{16}$/.test(normalizeInvitationCode(value))
}

export function invitationURL(value: string) {
  const code = formatInvitationCode(value)
  return isValidInvitationCode(code) ? `${INVITATION_HOST}/join/${code}` : null
}

export function savePendingInvitation(value: string) {
  const code = formatInvitationCode(value)
  if (!isValidInvitationCode(code)) return null
  window.sessionStorage.setItem(PENDING_INVITATION_KEY, code)
  return code
}

export function pendingInvitation() {
  if (typeof window === 'undefined') return null
  const code = formatInvitationCode(window.sessionStorage.getItem(PENDING_INVITATION_KEY) ?? '')
  return isValidInvitationCode(code) ? code : null
}

export function clearPendingInvitation() {
  window.sessionStorage.removeItem(PENDING_INVITATION_KEY)
}

export function invitationPath(value: string) {
  const code = formatInvitationCode(value)
  return `/join/${encodeURIComponent(code)}`
}

export function normalizeTeamInvitationCode(value: string) {
  return value.toUpperCase().replace(/[^A-Z0-9]/g, '').slice(0, 20)
}

export function formatTeamInvitationCode(value: string) {
  return normalizeTeamInvitationCode(value).match(/.{1,4}/g)?.join('-') ?? ''
}

export function isValidTeamInvitationCode(value: string) {
  return /^TEAM[0-9A-F]{16}$/.test(normalizeTeamInvitationCode(value))
}

export function teamInvitationURL(value: string) {
  const code = formatTeamInvitationCode(value)
  return isValidTeamInvitationCode(code) ? `${INVITATION_HOST}/team/join/${code}` : null
}

export function savePendingTeamInvitation(value: string) {
  const code = formatTeamInvitationCode(value)
  if (!isValidTeamInvitationCode(code)) return null
  window.sessionStorage.setItem(PENDING_TEAM_INVITATION_KEY, code)
  return code
}

export function pendingTeamInvitation() {
  if (typeof window === 'undefined') return null
  const code = formatTeamInvitationCode(window.sessionStorage.getItem(PENDING_TEAM_INVITATION_KEY) ?? '')
  return isValidTeamInvitationCode(code) ? code : null
}

export function clearPendingTeamInvitation() {
  window.sessionStorage.removeItem(PENDING_TEAM_INVITATION_KEY)
}
